module.exports = __webpack_public_path__ + "img/app-choice-assistant.aa76ce2a.png";